<template>
  <b-container class="p-0">
    <divalto-codes-form
      :componentData="editableCode"
      @save-code="handleSave"
      @toast-message="showToast"
    />
  </b-container>
</template>

<script>
import { ModalMixin } from '@/mixins';
import DivaltoCodesForm from '@/components/forms/DivaltoCodesForm.vue';

export default {
  name: "DivaltoCodeUpdate",
  mixins: [ModalMixin],
  components: {
    DivaltoCodesForm
  },
  props: {
    componentData: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      editableCode: { ...this.componentData }
    };
  },
  watch: {
    componentData: {
      handler(newCode) {
        this.editableCode = { ...newCode };
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    handleSave(codes) {
    },
    showToast({ message, variant }) {
      this.$bvToast.toast(message, {
        variant,
        solid: true,
      });
    },
  }
};
</script>
